@if(list !== undefined
&& list !== null
&& list!.length > 0)
{
    <mat-chip-set aria-label="Information">
        @for (item of list; track $index) {
        <mat-chip-row>
            {{item}}
        </mat-chip-row>
        }
    </mat-chip-set>
}